import React, { useState } from "react";
import { FaClock, FaQuestionCircle } from "react-icons/fa";
import { useCourseSelection } from "../../context/CourseSelectionContext";
import sendEmail from "../../utilities/sendEmail";

const ContactForm = () => {
  const { selectedCourse } = useCourseSelection();
  
  // Define courses data to match OurCourses.tsx
  const courses = [
    {
      id: 1,
      title: "Website - Full Stack Development",
      plans: ["Basic", "Standard", "Advanced"]
    },
    {
      id: 2,
      title: "Mobile App Full Stack Development",
      plans: ["Basic", "Standard", "Advanced"]
    },
    {
      id: 3,
      title: "Digital Marketing",
      plans: ["Basic", "Standard", "Advanced"]
    },
    {
      id: 4,
      title: "Creative Designing",
      plans: ["Basic", "Standard", "Advanced"]
    },
    {
      id: 5,
      title: "Communication Skills",
      plans: ["Basic", "Advanced"]
    },
    {
      id: 6,
      title: "Data Science & Analytics",
      plans: ["Standard", "Advanced"]
    }
  ];

  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    // subject: '',
    course: selectedCourse?.title || '',
    plan: selectedCourse?.selectedPlan?.name || '',
    message: ''
  });

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async(e: React.FormEvent) => {
    e.preventDefault();
    // Handle form submission here
    console.log('Form submitted:', formData);
    try {
      const customTemplate =`
      <html>
        <head>
          <style>
            body {
              font-family: Arial, sans-serif;
              line-height: 1.6;
              color: #333;
            }
            .container {
              max-width: 600px;
              margin: 20px auto;
              padding: 20px;
              border: 1px solid #ddd;
              border-radius: 5px;
            }
            .header {
              background-color: #f8f9fa;
              padding: 15px;
              margin-bottom: 20px;
              border-radius: 4px;
            }
            .details {
              margin: 20px 0;
            }
            .detail-row {
              margin: 10px 0;
            }
            .label {
              font-weight: bold;
              color: #555;
            }
          </style>
        </head>
        <body>
          <div class="container">
            <div class="header">
              <h2 style="color: #2c5282; margin: 0;">New Tech Institute Application</h2>
            </div>
            
            <div class="details">
              <div class="detail-row">
                <span class="label">Name:</span> ${formData.firstName} ${formData.lastName}
              </div>
              <div class="detail-row">
                <span class="label">Email:</span> ${formData.email}
              </div>
              <div class="detail-row">
                <span class="label">Phone:</span> ${formData.phone}
              </div>
              <div class="detail-row">
                <span class="label">Course of Interest:</span> ${formData.course}
              </div>
              <div class="detail-row">
                <span class="label">Plan:</span> ${formData.plan}
              </div>
              ${formData.message ? `
              <div class="detail-row">
                <span class="label">Message:</span><br>
                ${formData.message}
              </div>
              ` : ''}
            </div>
            
            <div style="color: #666; font-size: 12px; margin-top: 30px; border-top: 1px solid #eee; padding-top: 10px;">
              This is an automated message from the Insytix contact form.
            </div>
          </div>
        </body>
      </html>
      `;
      const response = await sendEmail(formData, false,customTemplate);
      if(response.status === 200) {
        alert('Your message has been sent successfully!');
        
        setFormData({
      firstName: '',
      lastName: '',
      email: '',
      phone: '',
      // subject: '',
      course: '',
      plan: '',
      message: ''
    });
      } 
    } catch (error) {
      console.error('Error sending message:', error);
      alert('There was an error sending your message. Please try again later.');
    }
    
  };

  // Update form data when selectedCourse changes
  React.useEffect(() => {
    setFormData(prev => ({
      ...prev,
      course: selectedCourse?.title || '',
      plan: selectedCourse?.selectedPlan?.name || ''
    }));
  }, [selectedCourse]);

  // Get available plans for selected course
  const getAvailablePlans = () => {
    const selectedCourseData = courses.find(c => c.title === formData.course);
    return selectedCourseData ? selectedCourseData.plans : [];
  };

  return (
    <div id="contact-form" className="py-16 px-4 bg-gray-50">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-4">
            Send Us a Message
            <div className="w-24 h-1 bg-blue-600 mx-auto mt-2"></div>
          </h2>
          <p className="text-sm md:text-base text-gray-600 max-w-3xl mx-auto">
            Have questions about our courses or need more information? Send us a message 
            and we'll get back to you within 24 hours.
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12">
          {/* Contact Form */}
          <div className="bg-white rounded-lg shadow-lg p-8">
            <form onSubmit={handleSubmit} className="space-y-6">
              <div className="grid md:grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm sm:text-base md:text-base lg:text-lg font-medium text-gray-700 mb-2">First Name</label>
                  <input
                    type="text"
                    name="firstName"
                    value={formData.firstName}
                    onChange={handleInputChange}
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  />
                </div>
                <div>
                  <label className="block text-sm sm:text-base md:text-base lg:text-lg font-medium text-gray-700 mb-2">Last Name</label>
                  <input
                    type="text"
                    name="lastName"
                    value={formData.lastName}
                    onChange={handleInputChange}
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  />
                </div>
              </div>

              <div>
                <label className="block text-sm sm:text-base md:text-base lg:text-lg font-medium text-gray-700 mb-2">Email Address</label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleInputChange}
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
              </div>

              <div>
                <label className="block text-sm sm:text-base md:text-base lg:text-lg font-medium text-gray-700 mb-2">Phone Number</label>
                <input
                  type="tel"
                  name="phone"
                  value={formData.phone}
                  onChange={handleInputChange}
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
              </div>

              {/* <div>
                <label className="block text-sm sm:text-base md:text-base lg:text-lg font-medium text-gray-700 mb-2">Subject</label>
                <input
                  type="text"
                  name="subject" */}
                  {/* // value={formData.subject}
                  onChange={handleInputChange}
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
              </div> */}

              {/* Course Selection Dropdown */}
              <div>
                <label className="block text-sm sm:text-base md:text-base lg:text-lg font-medium text-gray-700 mb-2">
                  Course of interest <span className="text-red-500">*</span>
                </label>
                <select
                  name="course"
                  value={formData.course}
                  onChange={handleInputChange}
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                >
                  <option value="">Select a course</option>
                  {courses.map((course) => (
                    <option key={course.id} value={course.title}>
                      {course.title}
                    </option>
                  ))}
                </select>
              </div>

              {/* Plan Selection Dropdown */}
              <div>
                <label className="block text-sm sm:text-base md:text-base lg:text-lg font-medium text-gray-700 mb-2">
                  Choose your plan <span className="text-red-500">*</span>
                </label>
                <select
                  name="plan"
                  value={formData.plan}
                  onChange={handleInputChange}
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                >
                  <option value="">What plan you need</option>
                  {getAvailablePlans().map((plan) => (
                    <option key={plan} value={plan}>
                      {plan}
                    </option>
                  ))}
                </select>
              </div>

              <div>
                <label className="block text-sm sm:text-base md:text-base lg:text-lg font-medium text-gray-700 mb-2">Your Message</label>
                <textarea
                  name="message"
                  value={formData.message}
                  onChange={handleInputChange}
                  rows={5}
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  placeholder="Tell us about your goals and how we can help you..."
                ></textarea>
              </div>

              <button
                type="submit"
                className="w-full bg-blue-600 text-white py-4 rounded-lg font-semibold hover:bg-blue-700 transition duration-300"
              >
                Send Message
              </button>
            </form>
          </div>

          {/* Information Sidebar */}
          <div className="space-y-8">
            {/* Office Hours */}
            <div className="bg-white rounded-lg shadow-lg p-8">
              <div className="flex items-center mb-4">
                <FaClock className="w-6 h-6 text-blue-600 mr-3" />
                <h3 className="text-xl sm:text-2xl md:text-2xl font-semibold text-gray-900">Office Hours</h3>
              </div>
              <div className="space-y-2 text-gray-600 text-sm sm:text-base md:text-base lg:text-lg">
                <div className="flex justify-between">
                  <span>Monday - Friday:</span>
                  <span>8:30 AM - 5:30 PM</span>
                </div>
                <div className="flex justify-between">
                  <span>Saturday:</span>
                  <span>8:30 AM - 1:00 PM</span>
                </div>
                <div className="flex justify-between">
                  <span>Sunday:</span>
                  <span>Closed</span>
                </div>
              </div>
            </div>

            {/* Quick Answers */}
            <div className="bg-white rounded-lg shadow-lg p-8">
              <div className="flex items-center mb-4">
                <FaQuestionCircle className="w-6 h-6 text-blue-600 mr-3" />
                <h3 className="text-xl sm:text-2xl md:text-2xl font-semibold text-gray-900">Quick Answers</h3>
              </div>
              <div className="space-y-4 text-sm sm:text-base md:text-base lg:text-lg">
                <div>
                  <h4 className="font-medium text-gray-900 mb-1 sm:text-base md:text-lg">How long are the courses?</h4>
                  <p className="text-gray-600 text-sm">Most courses range from 3-6 months with flexible scheduling options.</p>
                </div>
                <div>
                  <h4 className="font-medium text-gray-900 mb-1 sm:text-base md:text-lg">Do you provide job placement?</h4>
                  <p className="text-gray-600 text-sm">Yes, we offer comprehensive job placement assistance and career support.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactForm;

